import TypographyController from './typography.controller';
import { TypographyProps } from './typography.model';

const Typography = (props: TypographyProps): JSX.Element => {
  return <TypographyController {...props} />;
};

export default Typography;
